import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
// import { div } from "../../../components/div";
import "./styles.css";
import { ReactComponent as Darkthem } from "../../../assets/themes/Darkthem.svg";
import { ReactComponent as GreenThem } from "../../../assets/themes/Green.svg";
import { ReactComponent as Orange } from "../../../assets/themes/Orange.svg";
import { ReactComponent as LightThem } from "../../../assets/themes/LightThem.svg";
import { ReactComponent as Default } from "../../../assets/themes/Default.svg";
import { ReactComponent as NavyThem } from "../../../assets/themes/NavyThem.svg";
import { ReactComponent as InputBox } from "../../../assets/themes/Input.svg";
import { Dialog } from "primereact/dialog";
import { CustomButton } from "../../../components/CustomButton";
import Themspreview from "./ThemsPreview";
import axios from "axios";
import {
  fetchWhiteLabelCompany,
  saveWhiteLabelCompany,
} from "../../../reducers/whitelabelSlices";
import { useDispatch } from "react-redux";
import { Fieldset } from "primereact/fieldset";
import { API_GET_FILE_URL } from "../../../api/media.service";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import { useLayout } from "../../../context/LayoutContext";

const Whitelabel = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [logo, setLogo] = useState("");
  const [themsName, setThemsName] = useState("");
  const [activeThem, setActiveThems] = useState("");
  const [termsUrl, setTermsUrl] = useState("");
  const [rightsUrl, setRightsUrl] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const navigate = useNavigate();
  const { toastMassage, setLoading } = useLayout();


  const handleLogoClick = () => fileInputRef.current?.click();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setLogo(file);
  };

  const handleRemoveLogo = (e) => {
    e.stopPropagation();
    setLogo("");
    fileInputRef.current.value = "";
    setLogoUrl("");
  };

  const uploadImageFile = async () => {
    try {
      const resp = await API_GET_FILE_URL(companyId);
      const config = {
        onUploadProgress: (progressEvent) => {
          setUploadPercentage(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          );
        },
        headers: { "Content-Type": logo.type || "image/png" },
      };
      await axios.put(resp.data.src, logo, config);
      return resp.data.url;
    } catch (error) {
      console.error("Image upload failed:", error);
      return null;
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await dispatch(fetchWhiteLabelCompany(companyId)).unwrap();
      if (res.success) {
        setLogoUrl(res.data?.logoUrl || "");
        setRightsUrl(res.data?.rights || "");
        setTermsUrl(res.data?.termsConditionLink || "");
        setThemsName(res.data?.themeName || "default");
        setActiveThems(res.data?.themeName || "default");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Fetch failed:", error);
    }
  };

  const handlethemsSave = (data) => {
    dispatch(saveWhiteLabelCompany({ companyId: companyId, themeName: data }))
      .unwrap()
      .then(fetchData)
      .catch(console.error);
  };

  const handleSave = async () => {
    let uploadedLogoUrl = logoUrl;
    try {
      if (logo instanceof File) {
        uploadedLogoUrl = await uploadImageFile();
        if (!uploadedLogoUrl) return;
      }

      const payload = {
        companyId: companyId,
        logoUrl: uploadedLogoUrl || "",
        termsConditionLink: termsUrl.trim(),
        themeName: themsName || "default",
        rights: rightsUrl.trim(),
      };

      await dispatch(saveWhiteLabelCompany(payload)).unwrap();
      fetchData();
    } catch (error) {
      console.error("Save failed:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  return (
    <>
      <Loader />
      <Fieldset style={{ background: "#f8f8fc" }}>
        {/* Theme Selection */}

        <Fieldset className="mb-2" legend="Themes">
          <div className="section-wrapper">
            <div className="section-header">Theme Selection</div>
            <div className="section-description">
              Choose a color scheme that aligns with your brand identity
            </div>

            <div className="grid-container">
              {[
                ["Default Theme", Default, "default"],
                ["Light Theme", LightThem, "light"],
                ["Orange Theme", Orange, "orange"],
                ["Navy Theme", NavyThem, "navy"],
                ["Green Theme", GreenThem, "green"],
                // ["Dark Theme", Darkthem, "dark"],
              ].map(([label, Icon, key]) => {
                const isSelected = themsName === key;
                const isDisabled = key === "dark";
                return (
                  <div
                    key={key}
                    className={`relative grid-item border rounded-md p-2 transition group
    ${isSelected ? "border-dark-500 ring-2 ring-blue-300" : "border-gray-200"}
    ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}
    hover:bg-gray-100
  `}
                  >
                    <div className="themstitle">{label}</div>
                    <div className="thems_card">
                      <Icon />
                    </div>
                    <div className="theme-actions">
                      <CustomButton
                        varient="outline"
                        label="Preview"
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsOpen(true);
                          setThemsName(key);
                        }}
                      />
                      {activeThem !== key && (
                        <CustomButton
                          label="Activate"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlethemsSave(key);
                          }}
                        />
                      )}
                    </div>
                    {activeThem == key && (
                      <div className="activated-label">{label} Activated</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </Fieldset>
        {/* <hr /> */}
        <Fieldset legend="Company configuration">
          {/* Logo Upload */}
          <div className="section-wrapper">
            <div className="section-header">Company Logo</div>
            <div className="section-description">
              Upload your company logo to be displayed throughout the platform
            </div>

            <div className="company_logo">
              <div
                className="thems_footer"
                onClick={!logo ? handleLogoClick : undefined}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  const file = e.dataTransfer.files[0];
                  if (file?.type.startsWith("image/")) setLogo(file);
                }}
              >
                <input
                  type="file"
                  ref={fileInputRef}
                  hidden
                  onChange={handleFileChange}
                  accept="image/*"
                />
                {logo || logoUrl ? (
                  <div className="logo-preview-container">
                    <img
                      src={logo ? URL.createObjectURL(logo) : logoUrl}
                      alt="Logo Preview"
                      className="logo-preview"
                    />
                    <div className="logo-details">
                      <span className="logo-name">{logo?.name}</span>
                      <button
                        className="remove-logo-btn"
                        onClick={handleRemoveLogo}
                      >
                        Re-upload
                      </button>
                    </div>
                  </div>
                ) : (
                  <InputBox />
                )}
              </div>
            </div>
          </div>

          {/* Terms URL */}
          <div className="section-wrapper">
            <div className="section-header">Terms & Conditions URL</div>
            <div className="section-description">
              Link to your legal documentation that users must agree to
            </div>
            <input
              type="div"
              className="term_input"
              value={termsUrl}
              onChange={(e) => setTermsUrl(e.target.value)}
            />
          </div>

          {/* Rights URL */}
          <div className="section-wrapper">
            <div className="section-header">Company Name</div>
            <div className="section-description">
              Define your company name that will appear in the application
              footer
            </div>
            <input
              type="div"
              className="term_input"
              value={rightsUrl}
              onChange={(e) => setRightsUrl(e.target.value)}
            />
          </div>
          <div className="flex gap-2">
            <CustomButton label="Save" onClick={handleSave} />
            <CustomButton
              label="Back"
              varient="outline"
              onClick={() => navigate(-1)}
            />
          </div>
        </Fieldset>
        {/* Preview Dialog */}
        {isOpen && (
          <Dialog
            header="Theme Preview"
            visible={isOpen}
            onHide={() => setIsOpen(false)}
            draggable={false}
            footer={
              <div className="modal_footer">
                <CustomButton
                  onClick={() => setIsOpen(false)}
                  varient="div"
                  label="Cancel"
                />
              </div>
            }
            style={{ height: "90vh" }}
          >
            <div className="modal-container">
              <Themspreview themsName={themsName} />
            </div>
          </Dialog>
        )}
      </Fieldset>
    </>
  );
};

export default Whitelabel;
